import React, { useEffect, useState } from "react"
import { TableSchema, columnId, handleDoubleClickRow, rowDataPreprocesor } from "./scheme"
import PrimaryMenuBar from "../TicketActions/TicketUpdatesListingActions/PrimaryMenuBar"
import { getTicketUpdates } from "../../services/ticket.service"
import { useNavigate } from "react-router-dom"
import { DataTicketUpdate } from "../../models/ticket.model"
import DataTable from "../common/DataTable2"
import { useProject } from "../../context/ProjectContext"
import './index.css'
import { useNotification } from "../../context/NotificationContext"


export default function TicketsUpdatesListing(props: any) {
  const { ticket_number, ticket_status_n } = props

  const navigate = useNavigate()
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [ticketsUpdatesList, setTicketsUpdatesList] = useState<DataTicketUpdate[]>([]);
  const [loading, setLoading] = useState<boolean>(false)

  const [descriptionValue, setDescriptionValue] = useState<{ 'loaded': boolean, 'value': string }>({
    'loaded': false,
    'value': ''
  })

  const initComponent = () => {
    setLoading(true)
    Promise.all([getTicketUpdates(selectedProject, ticket_number)]).then(function (results) {
      setTicketsUpdatesList(results[0])
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
      showNotification(error.response.data, 'error');
    });
  };

  useEffect(initComponent, [])

  const handleDoubleClickUpdate = (rowData: DataTicketUpdate) => {
    handleDoubleClickRow(selectedProject, ticket_number, rowData.number, navigate)
  }

  const handleClickIdValue = (update_nbr: any) => {
    handleDoubleClickRow(selectedProject, ticket_number, update_nbr, navigate)
  }

  useEffect(() => {
    if (descriptionValue.loaded) {
      setDescriptionValue({ ...descriptionValue, ['loaded']: false })
    }
  }, [descriptionValue.loaded])

  return (
    <React.Fragment>

      <div className="ticket-updates-listing-section">
        <PrimaryMenuBar
          ticket_number={ticket_number}
          ticket_status_n={ticket_status_n}
        />

        <DataTable
          columns={TableSchema}
          rows={ticketsUpdatesList.map(rowDataPreprocesor)}
          loading={loading}
          onRowDoubleClick={handleDoubleClickUpdate}
          onClickIdValue={handleClickIdValue}
          columnId={columnId}
          hashtagPrefixId
          hasDetail

        />
      </div>

    </React.Fragment>
  );
}
